function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1134 4.42152C19.2519 -0.83353 26.7481 -0.833536 27.8866 4.42151L29.9311 13.8579C30.362 15.8467 31.9552 17.376 33.96 17.7251L41.7083 19.0741C47.2314 20.0358 47.2314 27.9643 41.7083 28.9259L33.9601 30.275C31.9552 30.624 30.362 32.1533 29.9311 34.1422L27.8866 43.5786C26.7481 48.8336 19.2519 48.8336 18.1134 43.5786L16.0689 34.1422C15.638 32.1533 14.0448 30.624 12.04 30.275L4.29172 28.9259C-1.23141 27.9643 -1.23141 20.0358 4.29172 19.0741L12.0399 17.7251C14.0448 17.376 15.638 15.8467 16.0689 13.8579L18.1134 4.42152Z",
  fill: "#434850"
});

function SvgLargeStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeStar);
export default __webpack_public_path__ + "static/media/largeStar.d672bb9d.svg";
export { ForwardRef as ReactComponent };